// event-previous-status-button-tw.tsx
import React from 'react';
import { getPreviousStatus, hasAdministrationRights } from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';

interface Props {
  eventFormStore: EventFormStore;
  readOnly: boolean;
  onPreviousStatus?: () => void;
}
const EventPreviousStatusButtonTw: React.FC<Props> = ({ eventFormStore, readOnly, onPreviousStatus }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event || !event.eventType) return null;

  const isVisible = hasAdministrationRights(event) && !!getPreviousStatus(event);
  if (!isVisible) return null;
  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      disabled={!readOnly}
      onClick={onPreviousStatus}
    >
      ←Previous
    </button>
  );
};
export default EventPreviousStatusButtonTw;
